module.exports = __webpack_public_path__ + "img/imagery_map.078b3740.jpeg";